export const en = {
  PEOPLE:'People',
  REGISTRANT: 'Registrant(s)',
  ADD_FILTER: 'Add Filter',
  ATTENDEE: 'Attendee(s)',
  MESSAGES: 'Messages',
  SALE: 'Sale',
  AVERAGE_TIME: 'Avg time on webinar',
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  COUNTRY: 'COUNTRY',
  EVENT_NAME: 'EVENT NAME',
  EVENT_TYPE: 'EVENT TYPE',
  SESSION_DATE: 'SESSION DATE',
  REGISTRATION_DATE: 'REGISTRATION DATE',
  LAST_REGISTRATION_DATE: 'LAST REGISTRATION DATE',
  TOTAL_SESSIONS: 'TOTAL SESSIONS',
  EVENT_ATTENDED: 'EVENT ATTENDED',
  REPLAY_ATTENDED: 'REPLAY ATTENDED',
  REVENUE: 'REVENUE',
  NO_DATA: 'No Data',
  ANALYTICS: 'Analytics',
  UNIQUE_VISITORS: 'Unique Visitors',
  WEBINAR_FUNNEL_STATS: 'Webinar Funnel Stats',
  WATCHED_REPLAY: 'Watched Replay',
  SUMMARY: 'Visitor & Registration Summary',
  EVENT_ACTIVITY: 'Event Activity',
  SELECT_SESSIONS: 'Select Session:',
  SELECT_SESSION_VIDEO: 'Select Session Video',
  CHAT_HOSTORY: 'Chat History',
  QUESTION_HOSTORY: 'Question List',
  CTA_STATS: 'CTA Stats ',
  VIEWS: 'Views',
  CLICKS: 'Clicks',
  SALES: 'Sales',
  RESPONSES: 'Responses',
  RECENT_REGISTRANTS: 'Recent Registrants',
  ATTENDEES: 'Attendees',
  APPLY_FILTER: "Apply Filter",
  REPLAY: "Replay",
  REPLAY_ROOM: "Replay Room",
  PURCHASED: "Purchased",
  WEBINAR_TAGS: "Webinar Tags",
  REG_SOURCE: "Registration Source",
  WEBINAR_AND_SESSIONS: "Webinar And Sessions",
  TOTAL_RECORDS: "Total Records",
  FILTERED_RECORDS: "Filtered Records",

  ATTENDEE_LIST: {
    REGISTRATION_FORM_INFORMATION: 'REGISTRATION FORM INFORMATION',
    EMAIL: 'Email',
    FULL_NAME: 'Full Name',
    PHONE: 'Phone',
    COUNTRY: 'Country',
    STATE: 'State',
    CITY: 'City',
    REGISTRATION_AND_ATTENDANCE: 'REGISTRATION AND ATTENDANCE',
    REGISTRATION_DATE: 'Registration Date',
    HAS_ATTENDED: 'Has Attended?',
    ATTENDANCE_DURATION: 'Attendance Duration',
    HAS_ATTENDED_REPLAY: 'Has Attended Replay?',
    TECHNICAL_INFORMATION: 'TECHNICAL INFORMATION',
    WEB_BROWSER: 'Web Browser',
    OPERATING_SYSTEM: 'Operating System',
    IP_ADDRESS: 'IP address',
    EVENT: 'EVENT',
    EVENT_ROOM: "Event Room",
    EVENTS:"Event",
    ALL_EVENTS: "All Events",
    SESSION: 'SESSION',
    ATTENDED: 'ATTENDED',
    ATTENDED_REPLAY: 'ATTENDED REPLAY',
    WEBINAR_AND_SESSIONS: ' Webinars And Sessions',
    USER_DETAILS: 'User Details',
    ATTENDANCE_RATE: ' Attendance Rate',
    CTA: "CTA's",
    ATTENDEDS: 'Attended',
    WATCH_REPLAY: 'Watch Replay',
    UTM_PARAMETERS: 'UTM Parameters',
    REGISTRATIONS_SOURCE: 'Registrations Source',
    DEVICE: 'Device',
    BROWSER: 'Browser',
    LOCATION: 'Location',
    TIME_ZONE: 'Time zone',
    SCHEDULE_TYPE: {
      ALL: 'All',
      SCHEDULED: 'Scheduled',
      INSTANT_REPLAY: 'Instant Replay',
      JIT: 'Just In Time',
    },
    REG_DATE_TYPE: {
      ALL: 'All',
      FIRST_REG: 'First Registration',
      LAST_REG: 'Last Registration',
    },
    ATTENDANCE_CONDITION: {
      EQUAL: 'Equal',
      GREATER: 'Greater Than',
      GREATER_OR_EQUAL: 'Greater Than or Equal to',
      LESS: 'Less Than',
      LESS_OR_EQUAL: 'Less Than or Equal to',
    },
    YES: 'Yes',
    NO: 'No',
    ALL:'All',
    UTM_SEARCH_LABEL:'Search for UTM keywords',
    BROWSER_SEARCH_LABEL:'Search for Chrome, Safari...',
    USER_SEARCH_LABEL: 'Search by name, email or phone...'
  },

  CTA_TYPE: {
    OFFERS: 'Offers',
    POLLS: 'Polls',
  },
  ALL_OFFERS: 'All Offers',
  ALL_POLLS: 'All Polls',
  OFFER_TAGS: {
    NOT_CLICKED: 'Saw the offer but did not click',
    CLICKED: 'Clicked the offer',
    DID_NOT_SEE: 'Did not see the offer',
  },
  POLL_TAGS: {
    ANSWERED_POLL: 'Answered Poll',
    VIEWED_BUT_NOT_ANSWERED: 'Viewed the poll but not answered',
    DID_NOT_SEE: 'Did not see the poll',
  },
  REG_SOURCE_OPTIONS: {
    ALL:'All',
    REG_PAGE: 'Registration Page',
    WIDGET: 'Widget',
    ONE_CLICK_REG: 'One Click Registration',
    ATTENDEE_JOIN_LINK: 'Attendee Join Link',
    ZAPIER: 'Zapier',
  },
  DEVICE_TYPE: {
    ALL: 'All',
    DESKTOP: 'Desktop',
    TABLET: 'Tablet',
    SMARTPHONE: 'Smartphone',
  },
  CLEAR_FILTERS: 'Clear filters',

  WEBINAR_LISTING: {
    WEBINARS: 'My Webinars',
    ADD_WEBINAR: 'Create a Webinar',
    LIVE: 'Live',
    SIMULATED_LIVE: 'Automated',
    EVERGREEN: 'Automated Gold',
    ARCHIVED: 'Archived',
    ALL_EVENTS:'All',
    EDIT: 'Change Settings',
    JOIN_ROOM: 'Go Live',
    REGISTRATION_PAGE_URL: 'View Registration Page',
    ARCHIVE: 'Archive',
    RESTORE_WEBINAR: 'Restore Webinar',
    NEXT_SESSION_SMALL: 'Upcoming Session',
    REVENUE: 'Revenue',
    TOTAL_SALES: 'Total Sales',
    REGISTRANTS: 'Registrants',
    VISITORS: 'Visitors',
    AVRG_DURATION: 'AVRG. DURATION',
    SESSIONS: 'SESSIONS',
    PAST_SESSIONS: 'PAST SESSIONS',
    NAME: 'NAME',
    NEXT_SESSION: 'NEXT SESSION',
    AVERAGE_DURATION: 'AVERAGE DURATION',
    LAST_SESSION: 'Last Session: --',
    UNARCHIVE: 'Unarchive',
    NO_WEBINAR: 'No webinars yet',
    NO_LIVE_WEBINAR: 'No live webinars yet',
    NO_SIMULATED_WEBINAR: 'No automated webinars yet',
    NO_EVERGREEN_WEBINAR: 'No  automated gold webinars yet',
    WEBINAR_LIST_EMPTY:
    'Click the button below to begin setting up your webinar.',
    WEBINAR_LIVE_LIST_EMPTY:'Click the button below to begin setting up your live webinar.',
    WEBINAR_SIMULATED_LIST_EMPTY:'Click the button below to begin setting up your automated webinar.',
    WEBINAR_EVERGREEN_LIST_EMPTY:'Click the button below to begin setting up your automated gold webinar.',

    NO_UPCOMING_SESSION:'No upcoming session' ,
    FIRST_WEBINAR:'Launch your first webinar',
    FIRST_WEBINAR_DESC: 'No webinars available yet. Lets start now by creating your first webinar',
    ATTENDEE_LOCAL_TIMEZONE: "Attendee's Local Timezone",
  },

  DELETE_CONFIRM: {
    ARE_YOU_SURE: 'Confirmation Required!',
    DELETE_RECORD_OPTION: 'Do you really want to archive this webinar?',
    EXIT_OPTION: 'Are you sure you want to exit?',
    CHANGES_NOT_SAVED: 'Changes not saved!',
    CANCEL: 'Cancel',
    NO: 'No',
    YES: 'Yes',
  },

  EVENT_RUNNING: {
    ALREADY_LIVE: 'You are already "LIVE" with one of your sessions',
    LIVE_NOW: 'GO LIVE NOW!',
    ONE_EVENT_LIVE:
      ' You can only be in one "Live" webinar at a time. Please select an action below: ',
    JOIN_WEBINAR: 'Join the ongoing live webinar session',
    NEW_WEBINAR_LIVE:
      'Stop the ongoing session and join from this webinar instead',
  },

  SELECT_SESSION: {
    ENTER_ROOM: 'Select a session to enter the room',
    ENTER_NOW: 'Enter Now',
  },
  WEBINAR_ANALYTICS:{
    COMING_SOON:"coming soon",
    TIME_POSTED:"Time Posted",
    NO_QUESTION_AVAIL:"Questions asked during your webinar will appear here.",
    NO_MESSAGE_AVAIL:"No message available yet",
    NO_DATA_AVAIL:"No data available yet",
    NO_REGIS_DATA:"No one has registered for this webinar yet.",
    SHOWING_RESULT:"Showing Result For:",
    QUESTION_PLACEHOLDER:"Filter Questions",
    CHAT_PLACEHOLDER:"Filter Chat",
    ATTENDEES:"Attendees",
    VIEWS:"Views",
    RESPONSES:"Responses",
    CLICKS:"Clicks",
    REVENUE:"Revenue",
    OFFER_SENT:"Offers",
    POLL_SENT:"Polls",
    VISITORS:"Visitors",
    REGISTRANTS:"Registrants",
    NO_QUESTION_WITH_SEARCH:"Nothing matches with your search",
    NO_CHAT_WITH_SEARCH:"Nothing matches with your search",
  },
  PEOPEL_PAGE:{
    NO_DATA_AVAIL:"No data available",
    NOTHING_MATCH_WITH_SEARCH:"Nothing matches with your search",
    TRY_SOMETHING_NEW:"Try something new.",
    CLEAR_FILTERS:"Clear some filters or try somthing new",
    LOCATION_PLACEHOLDER:"Search for country, state, city",
    NO_DATA_AVAIL_PEOPLE:"No registrants or attendees are available at this time",
    PLEASE_TRY_AFTER:"Please try after some time"

  }

};
